import API from '@/views/Fdc/Apis'
import _ from 'lodash'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. save validation check 테스트
// FIXME: 2. save 후 data 조회 시 save 한 data로 select 처리 필요한지 여부 판단
// FIXME: 3. 불필요 항목 삭제
// FIXME: 4. refresh 시 우측 grid 하단 status 초기화

/**
 * Admin > Code Manager
 * Code Type 및 Code 관리
 */
export default {
  name: 'codeManager',
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    this.searchCodeTypeList()
  },
  methods: {
    /**
     * Code Type List grid 및 Code List grid column 설정
     */
    initColumns () {
      const useYn = ['Y', 'N']

      this.codeTypeColumns = [
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.CODE_TYPE'), field: 'codeType', flex: 1, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.NAME'), field: 'codeTypeName', flex: 1, required: true, editable: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.NAME_ENG'), field: 'codeTypeNameEng', flex: 1, required: false, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', flex: 1, required: true, editable: true, cellEditor: 'agSelectCellEditor', cellEditorParams: { values: useYn } },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'codeTypeDesc', flex: 1, required: false, editable: true }
      ]
      this.codeColumns = [
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.CODE_TYPE'), field: 'codeType', flex: 1, required: true, hide: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.CODE'), field: 'codeId', flex: 1, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.NAME'), field: 'codeName', flex: 1, required: true, editable: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.NAME_ENG'), field: 'codeNameEng', flex: 1, required: false, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', flex: 1, dataMap: useYn, required: true, editable: true, cellEditor: 'agSelectCellEditor', cellEditorParams: { values: useYn } },
        { headerName: this.$t('fdc.COMMON.COLUMN.DISPLAY_ORDER'), field: 'displayOrder', flex: 1, required: true, type: 'numericColumn', editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'codeDesc', flex: 1, required: false, editable: true }
      ]
    },
    /**
     * Code Type 조회
     */
    async searchCodeTypeList () {
      const payload = {}
      await API.Admin.getCodeTypes(payload, this.codeTypeCallback, [this.$refs.codeTypeGrd])
    },
    /**
     * Code Type 조회 Callback
     * @param {Object} response Code type 조회 결과
     */
    codeTypeCallback (response) {
      if (response.status === 200 && response.data) {
        this.codeTypeDataRowData = response.data
        // TODO: 좀더 고려해볼 항목
        setTimeout(() => {
          this.$refs.codeTypeGrd.setFirstRowSelected()
        })
      }
    },
    /**
     * Code 조회
     */
    async searchCodeList () {
      if (!this.selectedCodeTypeData.codeType) return
      const payload = {
        codeType: this.selectedCodeTypeData.codeType
      }
      await API.Admin.getCodes(payload, this.codeCallback, [this.$refs.codeGrd])
    },
    /**
     * Code 조회 Callback
     * @param {Object} response Code 조회 결과
     */
    codeCallback (response) {
      if (response.status === 200 && response.data) {
        this.codeDataRowData = response.data
        // TODO: 좀더 고려해볼 항목
        this.$refs.codeGrd.initBriquegridDisplayArea()
      }
    },
    /**
     * Code Type Grid refresh
     */
    refreshCodeTypeList () {
      this.$refs.codeTypeGrd.onClickRefreshData()
    },
    /**
     * Code Type 저장 후 row 설정
     * @param {*} e focus 할 row
     */
    setCodeTypeLoadRow (e) {
      this.tmpCodeTypeSelLoadRow = {
        codeType: e.codeType
      }
    },
    /**
     * Code 저장 후 row 설정
     * @param {*} e focus 할 row
     */
    setCodeLoadRow (e) {
      this.tmpCodeSelLoadRow = {
        codeType: e.codeType,
        codeId: e.codeId
      }
    },
    /**
     * Save Validation 체크 및 Data 생성
     * @param {*} grid
     * @returns {*} Validation 성공 여부, save row data, modify row data
     */
    saveValidCheck (grid) {
      // const allRows = grid.rows
      // const totalModifiedRows = grid.totalModifiedRows
      const checkedRows = grid.getCheckedRows()
      const addedRows = grid.getAddedRows()
      const updatedRows = grid.getUpdatedRows()
      let totalModifiedRows = []
      totalModifiedRows.push(...addedRows)
      totalModifiedRows.push(...updatedRows)
      let saveRows = []

      let result = {
        inValid: false,
        saveRows: saveRows,
        totalModifiedRows: totalModifiedRows
      }

      // 선택된 데이터가 없습니다.
      if (checkedRows.length < 1) {
        this.$buefy.dialog.alert(this.T.M010)
        result.inValid = true
        return result
      }

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus === 'C' || rowStatus === 'U') {
          saveRows.push(row)
        }
      })

      // 변경된 데이터가 없습니다.
      if (saveRows < 1) {
        this.$buefy.dialog.alert(this.T.M011)
        result.inValid = true
        return result
      }

      if (this.saveDataValidCheck(checkedRows, grid)) {
        result.inValid = true
        return result
      }

      return result
      // 기존 로직 주석처리
      // const allRows = grid.rows
      // const checkedRows = allRows.filter(d => d.dataItem._status.checked)
      // const totalModifiedRows = grid.totalModifiedRows
      // let saveRows = []

      // let result = {
      //   inValid: false,
      //   saveRows: saveRows,
      //   totalModifiedRows: totalModifiedRows
      // }

      // // 선택된 데이터가 없습니다.
      // if (checkedRows.length < 1) {
      //   this.$buefy.dialog.alert(this.T.M010)
      //   result.inValid = true
      //   return result
      // }

      // allRows.some(row => {
      //   const rowStatus = row.dataItem._status
      //   // 변경되어 선택된 저장 대상
      //   if (rowStatus.checked && (rowStatus.added || rowStatus.modified)) {
      //     const item = _.clone(row.dataItem)
      //     delete item['_status']
      //     saveRows.push(item)
      //   }
      // })

      // // 변경된 데이터가 없습니다.
      // if (saveRows < 1) {
      //   this.$buefy.dialog.alert(this.T.M011)
      //   result.isValid = true
      //   return result
      // }

      // if (this.saveDataValidCheck(checkedRows, grid)) {
      //   result.isValid = true
      //   return result
      // }

      // return result
    },
    /**
     * 컬럼 필수 저장 값 check
     * @param {*} checkedRows check된 row data
     * @param {*} grid BRIQUE grid
     * @returns {Boolean} 체크 결과
     */
    saveDataValidCheck (checkedRows, grid) {
      // BRIQUE Grid
      const that = this
      return checkedRows.some(row => {
        const checkRequired = Object.keys(row).some(function (itemKey) {
          const column = grid.gridColumnApi.getColumn(itemKey)
          if (column != null) {
            const colDef = column.colDef
            const colValue = row[itemKey]
            if (colDef != null && colDef.required && that.isEmpty(colValue)) {
              console.log(colDef.required, colValue)
              that.tParam = [colDef.headerName]
              that.$buefy.dialog.alert(that.T.M001)
              return true
            }
          }
        })
        // 필수값
        if (checkRequired) { return true }
        // 중복값
        var dupIdx = this.rowItemDupCheck(row, grid)
        if (dupIdx > 0) {
          this.tParam = ['line : ' + dupIdx]
          this.$buefy.dialog.alert(this.T.M002)
          return true
        }
      })
      // 기존 로직 주석처리
      // const that = this
      // return checkedRows.some(row => {
      //   const checkRequired = Object.keys(row.dataItem).some(function (itemKey) {
      //     const column = grid.gridColumnsMap[itemKey]
      //     const colValue = row.dataItem[itemKey]
      //     if (column != null && column.required && that.isEmpty(colValue)) {
      //       that.tParam = [column.label]
      //       that.$buefy.dialog.alert(that.T.M001)
      //       return true
      //     }
      //   })
      //   // 필수값
      //   if (checkRequired) { return true }
      //   // 중복값
      //   var dupIdx = this.rowItemDupCheck(row.dataItem, grid)
      //   if (dupIdx > 0) {
      //     this.tParam = ['line : ' + dupIdx]
      //     this.$buefy.dialog.alert(this.T.M002)
      //     return true
      //   }
      // })
    },
    /**
     * 중복 체크
     * @param {*} item row data
     * @param {*} grid BRIQUE Grid
     * @returns {Boolean} 중복 체크 결과
     */
    rowItemDupCheck (item, grid) {
      let dupIdx = 0
      grid.getAllRows().some((row, idx) => {
        switch (grid.briqueGridId) {
          case 'BriqueGridcodeTypeGrd':
            if (this.itemCodeTypeDupCheck(item, row)) {
              dupIdx = idx + 1
              return true
            }
            break
          case 'BriqueGridcodeGrd':
            if (this.itemCodeDupCheck(item, row)) {
              dupIdx = idx + 1
              return true
            }
            break
        }
      })
      return dupIdx
    },
    /**
     * Code Type 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} row row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemCodeTypeDupCheck (item, row) {
      return !_.isEqual(item, row) && item.codeType === row.codeType
    },
    /**
     * Code 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} row row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemCodeDupCheck (item, row) {
      return !_.isEqual(item, row) && item.codeType === row.codeType && item.codeId === row.codeId
    },
    /**
     * Code Type 저장
     */
    async saveCodeTypeData () {
      const valid = this.saveValidCheck(this.$refs.codeTypeGrd)
      if (valid.inValid) {
        return false
      }

      let confirmMessage = ''
      if (!_.isEqual(valid.saveRows.length, valid.totalModifiedRows.length)) {
        confirmMessage = this.T.M012
      }
      confirmMessage += this.T.M013
      const that = this
      let payload = {
        dataList: valid.saveRows
      }
      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          const responseData = await API.Admin.saveCodeTypes(payload)
          if (responseData != null && responseData.status === 200) {
            that.$buefy.dialog.alert(that.T.M004)
            // TODO: 필요 시 추가
            // that.setCodeTypeLoadRow(valid.saveRows[0])
            that.searchCodeTypeList()
          } else {
            that.$buefy.dialog.alert(that.T.M005)
          }
        }
      })
    },
    /**
     * Code 저장
     */
    async saveCodeData () {
      const valid = this.saveValidCheck(this.$refs.codeGrd)
      if (valid.inValid) {
        return
      }

      let confirmMessage = ''
      if (!_.isEqual(valid.saveRows.length, valid.totalModifiedRows.length)) {
        confirmMessage = this.T.M012
      }
      confirmMessage += this.T.M013
      const that = this
      let payload = {
        dataList: valid.saveRows
      }
      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          const responseData = await API.Admin.saveCodes(payload)
          if (responseData != null && responseData.status === 200) {
            that.$buefy.dialog.alert(that.T.M004)
            // TODO: 필요 시 추가
            // that.setCodeTypeLoadRow(valid.saveRows[0])
            that.searchCodeList()
          } else {
            that.$buefy.dialog.alert(that.T.M005)
          }
        }
      })
    },
    /**
     * Row Data 분류
     * @param {*} grid brique grid
     * @returns {*} data Object
     * grid에 row를 분류한다. (check row, add한 row, delete row)
     */
    deleteDataCollector (grid) {
      // const allRows = grid.rows
      const checkedRows = grid.getCheckedRows()
      const addedRows = grid.getAddedRows()
      // const updatedRows = grid.getUpdatedRows()
      const deleteRows = checkedRows.filter(d => !(d.briqueGridCud === 'C') || !d.briqueGridCud)
      // let deleteRow = []
      // deleteRowWithStatus.forEach(row => {
      //   // 데이터 삭제 할 로우
      //   const item = _.clone(row.dataItem)
      //   delete item['_status']
      //   deleteRow.push(item)
      // })

      return {
        checkedRows: checkedRows,
        addedRow: addedRows,
        deleteRow: deleteRows
      }
    },
    /**
     * Code Type 삭제
     */
    deleteCodeTypeData () {
      const rowList = this.deleteDataCollector(this.$refs.codeTypeGrd)
      const that = this
      if (rowList.checkedRows < 1) {
        this.$buefy.dialog.alert(this.T.M010)
      }

      const confirmMessage = this.T.M014_1 + this.T.M014
      const completeMessage = this.T.M015

      let payload = {
        dataList: rowList.deleteRow
      }

      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          this.codeTypeDataRowData = []
          this.codeDataRowData = []
          if (rowList.deleteRow.length > 0) {
            await API.Admin.deleteCodeTypes(payload)
          }
          that.$buefy.dialog.alert(completeMessage)
          that.searchCodeTypeList()
        }
      })
    },
    /**
     * Code 삭제
     */
    deleteCodeData () {
      const rowList = this.deleteDataCollector(this.$refs.codeGrd)
      const that = this
      if (rowList.checkedRows < 1) {
        this.$buefy.dialog.alert(this.T.M010)
      }

      const confirmMessage = this.T.M014
      const completeMessage = this.T.M015

      let payload = {
        dataList: rowList.deleteRow
      }

      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          this.codeDataRowData = []
          if (rowList.deleteRow.length > 0) {
            await API.Admin.deleteCodes(payload)
          }
          that.$buefy.dialog.alert(completeMessage)
          that.searchCodeList()
        }
      })
    },
    /**
     * Grid Cell Edit End event
     * @param {*} grid 대상 grid
     * @param {*} event 이벤트
     * 수정된 row 자동 check
     */
    async cellEditEnd (grid, event) {
      let col = grid.columns[event.col]
      let rowStatus = grid.rows[event.row]._data._status

      // modified and added row 시 자동 check (checkbox column 제외)
      if (col.binding !== '_status.checked') {
        if (rowStatus.modified || rowStatus.added) {
          rowStatus.checked = true
        } else {
          rowStatus.checked = false
        }
      }
    },
    /**
     * Code type에서 선택한 Row 설정
     * @param {*} row
     */
    setCodeType (row) {
      this.selectedCodeTypeData = row
      if (row != null) {
        this.searchCodeList()
      } else {
        this.codeDataRowData = []
        // TODO: 좀더 고려해볼 항목
        this.$refs.codeGrd.initBriquegridDisplayArea()
      }
    },
    /**
     * Code Type List grid 신규 행 추가
     */
    codeTypeNewRowAdd () {
      let obj = {
        codeType: '',
        codeTypeName: '',
        codeTypeNameEng: '',
        useYn: 'Y',
        codeTypeDesc: '',
        isNew: true
      }
      this.$refs.codeTypeGrd.addRowOne(obj)
      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.codeTypeGrd.addRows(arr, status)
    },
    /**
     * Code List grid 신규 행 추가
     */
    codeNewRowAdd () {
      let obj = {
        codeType: this.selectedCodeTypeData.codeType,
        codeId: '',
        codeName: '',
        codeNameEng: '',
        useYn: 'Y',
        displayOrder: '',
        codeDesc: '',
        isNew: true
      }
      this.$refs.codeGrd.addRowOne(obj)
      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.codeGrd.addRows(arr, status)
    },
    /**
     * Code Type 선택 Row 상태 확인
     * @returns {Boolean} 선택된 row 있는지 여부
     */
    hasCodeTypeRow () {
      if (this.selectedCodeTypeData === null) {
        return false
      } else if (Object.keys(this.selectedCodeTypeData).length === 0) {
        return false
      } else if (this.selectedCodeTypeData.briqueGridCud && this.selectedCodeTypeData.briqueGridCud === 'C') {
        return false
      } else {
        return true
      }
    },
    /**
     * check된 row가 있는지 확인
     * @returns {*} check된 row 있는지 여부
     */
    hasCodeTypeCheckedRows () {
      if (!this.$refs.codeTypeGrd) {
        return 0
      }
      return this.$refs.codeTypeGrd.checkedRowCount > 0
    },
    /**
     * check된 row가 있는지 확인
     * @returns {*} check된 row 있는지 여부
     */
    hasCodeCheckedRows () {
      if (!this.$refs.codeGrd) {
        return 0
      }
      return this.$refs.codeGrd.checkedRowCount > 0
    },
    /**
     * BRIQUE grid selection change event
     * @param {*} rows selection rows
     */
    gridSelectionChanged (rows) {
      if (rows.length === 1) {
        var currentRow = rows[0]
        this.setCodeType(currentRow)
      } else {
        this.setCodeType(null)
      }
    },
    /**
     * null 값 check
     * @param {*} value check value
     */
    isEmpty (value) {
      if (value === '' || value === null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      selectedCodeTypeData: null, // 선택된 Code Type List grid row data
      selectedCodeData: null, // 선택된 Code List grid row data
      codeTypeColumns: [], // Code Type List grid columns 배열
      codeTypeDataRowData: [], // Code Type List grid row data
      codeColumns: [], // Code List grid columns 배열
      codeDataRowData: [], // Code List grid row data
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      tmpCodeTypeSelLoadRow: {}, // Code Type List 재조회를 위한 data
      tmpCodeSelLoadRow: {}, // Code List 재조회를 위한 data
      tParam: [] // 다국어 message parameter data
    }
  },
  computed: {
    T: function () {
      return {
        T001: this.$t('fdc.MANAGEMENT.TITLE.T0001'),
        T002: this.$t('fdc.MANAGEMENT.TITLE.T0002'),
        B001: this.$t('fdc.COMMON.BUTTON.REFRESH'),
        B002: this.$t('fdc.COMMON.BUTTON.ADD'),
        B003: this.$t('fdc.COMMON.BUTTON.SAVE'),
        B004: this.$t('fdc.COMMON.BUTTON.DELETE'),
        B005: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        B006: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        M001: this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', this.tParam),
        M002: this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', this.tParam),
        M004: this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'),
        M005: this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'),
        M010: this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'),
        M011: this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'),
        M012: this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA'),
        M013: this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE'),
        M014_1: this.$t('fdc.MANAGEMENT.MESSAGE.CONFIRM_DOWN_LEVEL_DELETE'),
        M014: this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE'),
        M015: this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')
      }
    }
  }
}
